import camelCase from 'camelcase'

export const camelCaseAddress2 = (address2) => {
    const address2StringArray = address2.split(" ");
    let address2CamelString = "";
    for (let item of address2StringArray) {
        address2CamelString += " " + camelCase(item, { pascalCase: true });
    }
    address2CamelString = address2CamelString.trim();
    return address2CamelString;
}
